export type statusTypes = {
  Customer: 'Customer';
  Dead: 'Dead';
  Duplicate: 'Duplicate';
  'Collection Hold': 'Collection Hold';
  Dormant: 'Dormant';
  Pending: 'Pending';
  Inactive: 'Inactive';
  'Credit Hold': 'Credit Hold';
};

export type ApprovedCarrier = {
  id: number;
  name: string;
  status: keyof statusTypes;
  mc: string;
  dot: string;
  mode: string;
  city: string;
  state: string;
  contact: string;
  phone: string;
  contactVerificationStatus: number;
  rating: number;
  loadsCompleted: number;
  fallouts: number;
  equipment: string[];
  modifiedDate: string;
  blacklisted: boolean;
  conditionalActionPlanReceived: boolean;
  hazmat: boolean;
  smartway: boolean;
  transfloEnabled: boolean;
  expiredInsurance: boolean;
  isDuplicate?: boolean;
};

export type ApprovedCarriersApiResponse = {
  totalCount: number;
  data: ApprovedCarrier[];
};

export type ApprovedCarrierQueryParams = {
  $top: number;
  $skip: number;
  $orderby: string;
  $format: string;
  $count: boolean;
  $filter?: string;
};

export type Carrier = {
  authorityGrantDate: string | null;
  mC: string;
  dOT: string;
  taxId: string | null;
  name: string;
  safetyRating: string;
  authoritySince: string;
  commonAuthority: boolean;
  contractAuthority: boolean;
  brokerAuthority: boolean;
  mailingAddress1: string;
  mailingAddress2: string | null;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  mailingCountry: string;
  carrierContacts: unknown[]; //  TODO :Change this to the correct type
  safetyWarnings: string | null;
  safetyWarningsDisplay: string | null;
  liabilityExpiration: string | null;
  liabilityInsuranceCompany: string | null;
  liabilityLimit: string | null;
  liabilityPolicyNumber: string | null;
  cargoExpiration: string | null;
  cargoInsuranceCompany: string | null;
  cargoLimit: string | null;
  cargoPolicyNumber: string | null;
  workersCompExpiration: string | null;
  workersCompInsuranceCompany: string | null;
  workersCompLimitEachAccident: number;
  workersCompLimitDisease: number;
  workersCompLimitPolicy: string | null;
  workersCompPolicyNumber: string | null;
  physicalAddress1: string;
  physicalCity: string;
  physicalState: string;
  physicalZip: string;
  physicalCountry: string;
  id: number;
  status: string | null;
  factors: boolean;
  companyRep: string;
  companyRepEmail: string;
  companyRepPhoneNumber: string;
  corporatePhoneNumber: string | null;
  smartwayCertified: boolean;
  hazmatCertified: boolean;
  entityType: string;
  rAOverall: string;
  rAAuthority: string;
  rAInsurance: string;
  rASafety: string;
  rAOperation: string;
  rAOther: string;
  accidentRate: number;
  crashFatalUS: number;
  crashInjuryUS: number;
  crashTowUS: number;
  crashTotalUS: number;
  crashFatalCAN: number;
  crashInjuryCAN: number;
  crashTowCAN: number;
  crashTotalCAN: number;
  inspectVehUS: number;
  inspectVehOOSUS: number;
  inspectVehOOSPctUS: number;
  inspectDrvUS: number;
  inspectDrvOOSUS: number;
  inspectDrvOOSPctUS: number;
  inspectHazUS: number;
  inspectHazOOSUS: number;
  inspectHazOOSPctUS: number;
  inspectIEPUS: number;
  inspectIEPOOSUS: number;
  inspectIEPOOSPctUS: number;
  inspectVehCAN: number;
  inspectVehOOSCAN: number;
  inspectVehOOSPctCAN: number;
  inspectDrvCAN: number;
  inspectDrvOOSCAN: number;
  inspectDrvOOSPctCAN: number;
  fleetSize: string;
  powerUnits: number;
  drivers: number;
  trucks: number;
  trailers: number;
  tractors: number;
  carrierCertificates: unknown[]; // TODO: Change this to the correct type
};

export type LookUpDataResponse = {
  carrier: Carrier;
  valid: boolean;
};

export type LookUpApiResponse = {
  success: boolean;
  data: LookUpDataResponse;
  message: string | null;
};

export type CarrierEditHistoryItem = {
  action: string;
  field: string;
  description: string;
  timeStamp: string;
  oldValue: null;
  newValue: string;
  editedBy: string;
  historyType: string;
};

export enum DataSource {
  Internal = 0,
  ATG = 1,
  Highway = 2,
  DAT = 3,
}

export type PreferredLaneT = {
  id: number;
  carrierId: number;
  originLane: string;
  originCity: string;
  originState: string;
  originPostal: string;
  originCountry: string;
  originLatitude: number;
  originLongitude: number;
  destinationLane: string;
  destinationCity: string;
  destinationState: string;
  destinationPostal: string;
  destinationCountry: string;
  destinationLatitude: number;
  destinationLongitude: number;
  equipmentCategory: number;
  canDelete: boolean;
  source: DataSource;
  createdDate: string;
  createdBy: number;
  modifiedDate: string;
  modifiedBy: number;
  historyContext: string;
  truckCreationSucceeded?: boolean;
};

export type EquipmentT = {
  equipmentId: number;
  equipmentName: string;
};

export type EquipmentCategoryT = {
  categoryId: number;
  categoryName: string;
  equipment: EquipmentT[];
};
